export default __webpack_public_path__ + "static/media/640_store05-fr-mobile.3a79b802.png";